import tools from 'utils/tools';

const ProtectedRoute = tools.lazyWithRetry(() =>
  import('layouts/RouteAccessModifiers'),
);
const DashboardLayout = tools.lazyWithRetry(() =>
  import('layouts/DashboardLayout'),
);
const ReminderIndex = tools.lazyWithRetry(() =>
  import('components/pages/Reminder/ReminderIndex'),
);
const ReminderAddStep1 = tools.lazyWithRetry(() =>
  import('components/pages/Reminder/ReminderAddStep1'),
);
const ReminderAddStep2 = tools.lazyWithRetry(() =>
  import('components/pages/Reminder/ReminderAddStep2'),
);
const ReminderEdit = tools.lazyWithRetry(() =>
  import('components/pages/Reminder/ReminderEdit'),
);
const ReminderDetail = tools.lazyWithRetry(() =>
  import('components/pages/Reminder/ReminderDetail'),
);

const reminderRoutes = [
  {
    path: '/reminder',
    element: (
      <ProtectedRoute device>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: '', element: <ReminderIndex /> },
      { path: 'add/step-1', element: <ReminderAddStep1 /> },
      {
        path: 'add/step-2/:latitude/:longitude/:radius',
        element: <ReminderAddStep2 />,
      },
      { path: 'edit/:id', element: <ReminderEdit /> },
      { path: 'detail/:id', element: <ReminderDetail /> },
    ],
  },
];

export default reminderRoutes;
